module.exports = __webpack_public_path__ + "img/prescriptionQuantityFirst.85f90052.svg";